import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavDashboardFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "1em",
	viewBox: "0 -960 960 960",
	width: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		transform: "translate(0,-960) scale(40)",
		children: /* @__PURE__ */ _jsx("path", { d: "M12.9996 10.9996V2.09961C15.3829 2.34961 17.3954 3.29961 19.0371 4.94961C20.6788 6.59961 21.6329 8.61628 21.8996 10.9996H12.9996ZM11.0246 21.8746C8.49128 21.6246 6.37044 20.5579 4.66211 18.6746C2.95378 16.7913 2.09961 14.5663 2.09961 11.9996C2.09961 9.41628 2.95378 7.18294 4.66211 5.29961C6.37044 3.41628 8.49128 2.34961 11.0246 2.09961V21.8746ZM12.9996 21.8746V12.9746H21.8996C21.6663 15.3579 20.7204 17.3788 19.0621 19.0371C17.4038 20.6954 15.3829 21.6413 12.9996 21.8746Z" })
	})
});
export default SvgNavDashboardFill;
